// namespace
export const DOC_MANAGMENT_NAMESPACE = 'documentManagement'

// Getters
export const DOCUMENT_ACCOUNTS = 'documentAccounts'
export const NET_RCLM_AWAITING_DOCS = 'netReclaimAwaitingDocuments'
export const DOC_COUNT = 'documentCount'
export const TRANS_COUNT = 'transactionCount'
export const EVENT_COUNT = 'eventCount'
export const CLIENT_STATUS_GROUPS = 'clientStatusGroups'
export const COUNTRY_GRUOPS = 'countryGroups'
export const FI_ACCT_GROUPS = 'fiAccountGroups'
export const IS_LOADING = 'isLoading'
export const DOCUMENT_EXPORT_LOADING = 'documentExportLoading'
export const TRANSACTION_EXPORT_LOADING = 'transactionExportLoading'
export const REPORT_LOADING = 'reportLoading'
export const PRE_FILTERS = 'preFilters'
export const GROUP_BY = 'groupBy'
export const CLIENT_DOCS_ONLY = 'clientDocsOnly'
export const API_ERROR_OCCURRED = 'apiErrorOccurred'

// Mutations
export const SET_DOCUMENT_ACCOUNTS = 'setDocumentAccounts'
export const SET_DOCUMENTS = 'setDocuments'
export const SET_IS_LOADING = 'setIsLoading'
export const SET_DOCUMENT_EXPORT_LOADING = 'setDocumentExportLoading'
export const SET_TRANSACTION_EXPORT_LOADING = 'setTransactionExportLoading'
export const SET_PRE_FILTERS = 'setPreFilters'
export const SET_GROUP_BY = 'setGroupBy'
export const SET_CLIENT_DOCS_ONLY = 'setClientDocsOnly'
export const SET_ERROR_OCCURRED = 'setErrorOccurred'

// Actions
export const UPDATE_DOCUMENT_ACCOUNTS = 'updateDocumentAccounts'
export const UPDATE_DOCUMENTS = 'updateDocuments'
export const UPDATE_PRE_FILTERS = 'updatePreFilters'
export const UPDATE_GROUP_BY = 'updateGroupBy'
export const UPDATE_CLIENT_DOCS_ONLY = 'updateClientDocsOnly'
export const DOWNLOAD_DOCUMENT_EXCEL = 'downloadDocumentExcel'
export const DOWNLOAD_ITEM_EXCEL = 'downloadItemExcel'

// Enum
export const PARTNERSHIP_TYPES = {
  INVESTOR: {
    name: 'Investor',
  },
  PARTNERSHIP: {
    name: 'Partnership',
  },
  NON_PARTNERSHIP: {
    name: 'Non-Partnership',
  },
}

export const GROUP_BY_OPTIONS = {
  BO: {
    name: 'bo',
    display: 'Beneficial Owner - <em class="helper-text">Default</em>',
    settings: {
      visibilities: {
        boVis: true,
        mktVis: false,
        custVis: false,
        acctVis: false,
      },
      widths: {
        boWidth: null,
        mktWidth: null,
        custWidth: null,
        acctWidth: null,
      },
    },
  },
  BO_ACCT_FI_COI: {
    name: 'bo-acct-fi-coi',
    display: 'Market / Account',
    settings: {
      visibilities: {
        boVis: true,
        mktVis: true,
        custVis: true,
        acctVis: true,
      },
      widths: {
        boWidth: '35%',
        mktWidth: '10%',
        custWidth: null,
        acctWidth: null,
      },
    },
  },
  BO_ACCT: {
    name: 'bo-acct',
    display: 'Account',
    settings: {
      visibilities: {
        boVis: true,
        mktVis: false,
        custVis: true,
        acctVis: true,
      },
      widths: {
        boWidth: null,
        mktWidth: null,
        custWidth: 'auto',
        acctWidth: 'auto',
      },
    },
  },
  BO_COI: {
    name: 'bo-coi',
    display: 'Market / Beneficial Owner',
    settings: {
      visibilities: {
        boVis: true,
        mktVis: true,
        custVis: false,
        acctVis: false,
      },
      widths: {
        boWidth: '70%',
        mktWidth: null,
        custWidth: null,
        acctWidth: null,
      },
    },
  },
  SUB_INVESTOR: {
    name: 'sub-investor',
    display: 'Investor',
    settings: {
      visibilities: {
        boVis: true,
        mktVis: false,
        custVis: false,
        acctVis: false,
      },
      widths: {
        boWidth: null,
        mktWidth: null,
        custWidth: null,
        acctWidth: null,
      },
    },
  },
}
